// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__VjVFB","paper":"paper__ENKmH"};